import { z } from "zod";

const amount = /^-?\d+(?:\.\d{1,3})?$/;

export const openAccountSchema = z.object({
  name: z.string().trim().min(1, "Give the account a name.").max(120),
  reference: z.string().trim().max(100, "A reference is at most 100 characters."),
  currency: z.enum(["GEL", "USD", "EUR", "GBP", "TRY", "RUB", "JPY", "KWD", "UAH", "VND", "PLN", "CHF"]),
  openingAmount: z.string().trim().refine((value) => value === "" || amount.test(value), "Enter a valid signed amount."),
  effectiveAt: z.string().min(1, "Choose when this balance became true."),
  manualRate: z.string().trim().refine(
    (value) => value === "" || /^\d+(?:\.\d+)?$/.test(value),
    "Use a positive decimal exchange rate.",
  ),
});

export type OpenAccountForm = z.infer<typeof openAccountSchema>;
